import React,{useEffect,useRef,useState} from 'react';
import {createProtectedStream} from './protectedStream';
import FilterPicker from './FilterPicker';
import {FILTERS} from './FaceFiltersRegistry';
import BackgroundPicker from './BackgroundPicker';
import './QueuePreview.css';
export default function QueuePreview({filter,background,onFilter,onBackground}){
 const video=useRef(null),filterRef=useRef(filter),backgroundRef=useRef(background);
 filterRef.current=filter;backgroundRef.current=background;
 const [filtersOpen,setFiltersOpen]=useState(false);
 const [error,setError]=useState(''),[status,setStatus]=useState(''),[attempt,setAttempt]=useState(0);
 useEffect(()=>{
  let cancelled=false,raw,processed;
  const stop=()=>{processed?.stop();raw?.getTracks().forEach(track=>track.stop());};
  setError('');setStatus('loading');
  (async()=>{
   try{
    raw=await navigator.mediaDevices.getUserMedia({video:{facingMode:'user',width:{ideal:480},height:{ideal:360},frameRate:{ideal:24,max:24}},audio:false});
    if(cancelled){stop();return;}
    processed=createProtectedStream(raw,()=>false,()=>filterRef.current,state=>{if(!cancelled)setStatus(state);},{getBackground:()=>backgroundRef.current,previewWidth:480,frameRate:24});
    video.current.srcObject=processed.stream;await video.current.play();
   }catch{stop();if(!cancelled){setStatus('');setError('לא ניתן להפעיל תצוגה מקדימה. החיפוש ממשיך כרגיל.');}}
  })();
  return()=>{cancelled=true;stop();};
 },[attempt]);
 return <section className="queue-preview" aria-label="הכנה לווידאו בזמן החיפוש">
  <h3>בינתיים, בוחרים את הלוק שלכם</h3><p>התצוגה רק אצלכם. הבחירות יישמרו לשלב הווידאו אחרי השיחה הקולית.</p>
  <video ref={video} muted playsInline aria-label="תצוגת מצלמה לפני ההתאמה"/>
  {status==='loading'&&<p role="status">מכינים את תצוגת המצלמה…</p>}
  {status==='no-face'&&<p role="status">מקמו את הפנים מול המצלמה</p>}
  {error&&<p role="status">{error} <button type="button" onClick={()=>setAttempt(v=>v+1)}>ניסיון נוסף</button></p>}
  <div className="appearance-picker-row">
  <details className="background-picker queue-face-picker" onToggle={e=>setFiltersOpen(e.currentTarget.open)}><summary>פילטר לפנים <span>{FILTERS[filter]?.name || 'ללא פילטר'}</span></summary>{filtersOpen&&<FilterPicker value={filter} onChange={onFilter}/>}</details>
  <BackgroundPicker value={background} onChange={onBackground}/>
  </div>
 </section>;
}
